import { YouTubeVideoWordpress } from './entities';

export const youtubeDurationToSeconds = (duration: string): number => {
  if (duration === 'P0D') return 0;

  // TODO: this needs to be worked out
  let match: (string | null)[] | null = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);

  match =
    match &&
    match.slice(1).map(x => {
      if (x != null) {
        return x.replace(/\D/, '');
      }
      return null;
    });

  if (match) {
    const hours = parseInt(match[0] ?? '0') || 0;
    const minutes = parseInt(match[1] ?? '0') || 0;
    const seconds = parseInt(match[2] ?? '0') || 0;
    return hours * 3600 + minutes * 60 + seconds;
  }

  return 0;
};

export const formatToYouTubeVideoCard = (video: YouTubeVideoWordpress) => {
  if (!video) return null;
  return {
    contentDetails: {
      duration: video.contentDetails?.duration || '',
    },
    title: video.title || '',
    video_id: video.video_id || '',
  };
};

export const formatToVideoCard = (video: { id: string; title: string }) => {
  if (!video) return null;
  return {
    href: `https://www.youtube.com/watch?v=${video.id}`,
    id: video.id,
    image: `https://i.ytimg.com/vi/${video.id}/hq720.jpg`,
    title: video.title,
  };
};
